import { useSuspenseQuery } from "@apollo/client";
import { useMetaFilterConfig } from "./meta-filter-config";
import { GET_FILTER_META_INFO } from "../api/get-filter-meta-info";
import {
  DynamicAttributeFieldListFragment,
  FilterableEntity,
} from "gql/graphql";

export function useFilterMeta() {
  const config = useMetaFilterConfig();

  const { data } = useSuspenseQuery(GET_FILTER_META_INFO, {
    variables: {
      filterableEntity: config?.filterableEntity as FilterableEntity,
    },
    skip: !config?.filterableEntity,
  });

  const meta: DynamicAttributeFieldListFragment = {
    __typename: "DynamicAttributeValuesDto",
    attributes:
      data?.getFilterMetaInfo.attributes.filter(
        (attr) => !config?.exclude?.includes(attr.attributeCode),
      ) ?? [],
    groups:
      data?.getFilterMetaInfo.groups.map((group) => {
        return {
          ...group,
          attributes: group.attributes.filter(
            (attr) => !config?.exclude?.includes(attr.attributeCode),
          ),
        };
      }) ?? [],
  };

  return meta;
}
